import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFDefaultByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFDefaultByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderID: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        hasBaseAccessReq: '$..HasBaseAccessReq',
        baseAccessReqNotes: '$..BaseAccessReqNotes',
        dateEquipmentReq: '$..DateEquipmentReq',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
